import { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { t } from "../../translations";

import "../styles/section-chef.css";

import { useSelector } from "react-redux";

import ChefIcon from "../../assets/chef-icon.png";
import Phone from "../../assets/phone.png";

import Check from "../../assets/check.png";
import Uncheck from "../../assets/uncheck.png";

import { IoIosArrowForward } from "react-icons/io";
import { bankingService } from "../../services/bankingService";
import { GET } from "../constants/request-type";
import { service_api } from "../constants/url";
import { MakeRequestAsync } from "../functions/axios";
import { decryptSingleData } from "../functions/cryptojs";
import SubscriptionCountdownBanner from "./SubscriptionCountdownBanner";
import SubscriptionPaywallModal from "./SubscriptionPaywallModal";

import { createLogger } from "../../utils/logger";

const logger = createLogger("BasicInfo");

const BasicInfo = () => {
  let user = useSelector((state) => state.user);
  let lang = useSelector((state) => state.lang);
  const history = useHistory();

  const [profil] = useState({
    preview: user?.preview,
    pic1: user?.pic1,
    pic2: user?.pic2,
    firstname: user?.firstname,
    lastname: user?.lastname,
    email: user?.email,
    number: user?.number,
    bio: user?.bio,
    notification: user?.notification,
    notification_cancel: user?.notification_cancel,
    order_timing: user?.order_timing,
    country: user?.country,
    geographical_tag: user?.geographical_tag,
    certificate_pic: user?.certificate_safety?.pic,
    certificate_exp: user?.certificate_safety?.expirity,
    availability: user?.availability,
    few_days: user?.few_days,
    planned_days: user?.planned_days
  });

  const [count, setCount] = useState(0);
  const [showPaywallModal, setShowPaywallModal] = useState(false);
  const [bankingStatus, setBankingStatus] = useState(null);
  const [favoriteCount, setFavoriteCount] = useState(0);
  const [followerCount, setFollowerCount] = useState(0);
  const [rating, setRating] = useState(0);
  const [reviewCount, setReviewCount] = useState(0);
  const [incomingOrdersCount, setIncomingOrdersCount] = useState(0);
  const [pendingOrdersCount, setPendingOrdersCount] = useState(0);
  const [totalOrdersCount, setTotalOrdersCount] = useState(0);

  const countDish = useCallback(async () => {
    try {
      const response = await MakeRequestAsync({
        type: GET,
        url: service_api,
        route: `food/count-chef-food/${user?._id}`,
        data: null,
        token: user?.refresh_token
      });
      setCount(response.data.count);
    } catch (err) {
      // Handle error silently or show user-friendly message
      logger.error("Failed to count dishes:", err);
    }
  }, [user?._id, user?.refresh_token]);

  const loadBankingStatus = useCallback(async () => {
    try {
      const statusResponse = await bankingService.verifyAccount(
        user._id,
        user.refresh_token
      );
      setBankingStatus(statusResponse);
    } catch (error) {
      // Handle 404 gracefully - user hasn't set up banking yet
      if (
        error.response?.status === 404 ||
        error.message?.includes("not found")
      ) {
        logger.info("No Stripe Connect account found for user");
        setBankingStatus({ status: "pending", payouts_enabled: false });
      } else {
        logger.error("Failed to load banking status:", error);
      }
    }
  }, [user._id, user.refresh_token]);

  const loadChefStats = useCallback(async () => {
    try {
      const response = await MakeRequestAsync({
        type: GET,
        url: service_api,
        route: `user/get-chef-user/${user?._id}`,
        data: null,
        token: user?.refresh_token
      });

      // Decrypt the chef data
      const chefData = decryptSingleData(response.data.user);
      setFavoriteCount(chefData.favoriteCount || 0);
      setFollowerCount(chefData.followerCount || 0);
      setReviewCount(chefData.review_count || 0);

      // Calculate average rating
      if (chefData.review_count > 0) {
        setRating((chefData.stars_count / chefData.review_count).toFixed(1));
      } else {
        setRating(0);
      }
    } catch (err) {
      logger.error("Failed to load chef stats:", err);
    }
  }, [user?._id, user?.refresh_token]);

  const loadOrderStats = useCallback(async () => {
    try {
      const response = await MakeRequestAsync({
        type: GET,
        url: service_api,
        route: `order/get-chef-orders/${user?._id}`,
        data: null,
        token: user?.refresh_token
      });

      // Decrypt the orders data
      const orders = (decryptSingleData(response.data.order)) || [];
      setTotalOrdersCount(orders.length);

      // Count orders by status
      // Status 0: waiting/incoming
      // Status 0,1,2: pending (not yet delivered)
      const incoming = orders.filter((order) => order.status === 0).length;
      const pending = orders.filter(
        (order) =>
          order.status === 0 || order.status === 1 || order.status === 2
      ).length;

      setIncomingOrdersCount(incoming);
      setPendingOrdersCount(pending);
    } catch (err) {
      logger.error("Failed to load order stats:", err);
    }
  }, [user?._id, user?.refresh_token]);

  useEffect(() => {
    countDish();
    loadBankingStatus();
    loadChefStats();
    loadOrderStats();
  }, [countDish, loadBankingStatus, loadChefStats, loadOrderStats]);

  return (
    <div className="section-chef-menu-right-important">
      {/* Subscription Countdown Banner */}
      <SubscriptionCountdownBanner
        onShowPaywall={() => setShowPaywallModal(true)}
        lang={lang || "en"}
      />

      <img
        alt="icon-chef"
        src={ChefIcon}
        style={{
          marginTop: 20
        }}
      />

      <p
        style={{
          marginTop: 20,
          fontSize: 20,
          fontWeight: 600,
          color: `#000`
        }}
      >
        {t("common.best_chefs_earn", lang, user?.restaurant)}{" "}
      </p>
      <p
        style={{
          marginTop: -10,
          fontSize: 16,
          fontWeight: 500,
          color: "#5b5b5b"
        }}
      >
        {t("validation.fill_up_all_inf", lang)}{" "}
      </p>

      {/* Chef Stats Display */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: 20,
          marginTop: 20,
          flexWrap: "wrap",
          alignItems: "center"
        }}
      >
        <span
          style={{
            fontSize: 16,
            fontWeight: 500,
            color: "#e74c3c"
          }}
        >
          ❤️ {t("section_food_list.favorite", lang)} ({favoriteCount})
        </span>

        <span
          style={{
            fontSize: 16,
            fontWeight: 500,
            color: "#f39c12"
          }}
        >
          ⭐ {t("common.rating", lang)} ({rating})
        </span>

        <span
          style={{
            fontSize: 16,
            fontWeight: 500,
            color: "#95a5a6"
          }}
        >
          👥 {t("section_food_list.follow", lang)} ({followerCount})
        </span>

        <span
          style={{
            fontSize: 16,
            fontWeight: 500,
            color: "#3498db"
          }}
        >
          📦 {t("common.orders", lang)} ({totalOrdersCount})
        </span>

        <span
          style={{
            fontSize: 16,
            fontWeight: 500,
            color: "#27ae60"
          }}
        >
          🔔 {t("common.incoming_orders", lang)} ({incomingOrdersCount})
        </span>

        <span
          style={{
            fontSize: 16,
            fontWeight: 500,
            color: "#e67e22"
          }}
        >
          ⏳ {t("common.pending_orders", lang)} ({pendingOrdersCount})
        </span>
      </div>
      <div
        className="section-chef-menu-right-important-menu"
        style={{
          marginTop: 40
        }}
      >
        <div className="section-chef-menu-right-important-menu-inside basic-info-checklist-container">
          <p className="basic-info-checklist-title">
            {t("common.required_information", lang)}
          </p>

          {/* Internationalize text for chef onboarding checklist - Reordered based on user feedback */}
          {[
            {
              text: t("common.select_a_type_o", lang),
              sub: t("common.your_cuisine_ty", lang),
              onPress: () => {
                return history.push("/chef/iam-a-chef/cuisine");
              },
              validator: () => {
                return user?.speciality_tag && user?.speciality_tag.length > 0;
              }
            },
            {
              text: t("buttons.add_your_first_", lang),
              sub: t("common.dish_details_4", lang),
              onPress: () => {
                return history.push("/chef/iam-a-chef/menu");
              },
              validator: () => {
                return count > 0;
              }
            },
            {
              text: t("validation.fill_up_your_ch", lang, user?.restaurant),
              sub: t("common.talk_briefly_ab_1", lang),
              onPress: () => {
                return history.push("/chef/iam-a-chef/profil");
              },
              validator: () => {
                // Check if all mandatory profile fields are completed
                return (
                  user?.firstname &&
                  user?.lastname &&
                  user?.email &&
                  user?.number &&
                  user?.bio &&
                  user?.geographical_tag &&
                  user?.geographical_tag.length > 0 &&
                  user?.country &&
                  user?.max_dish &&
                  user?.preview &&
                  user?.pic1 &&
                  user?.pic2 &&
                  user?.pic3
                );
              }
            },
            {
              text: t("common.where_do_we_col", lang),
              sub: t("buttons.pickup_address", lang),
              onPress: () => {
                return history.push("/chef/iam-a-chef/address");
              },
              validator: () => {
                return (
                  user?.street &&
                  user?.position?.coordinates[0] &&
                  user?.position?.coordinates[1]
                );
              }
            },
            // Only show hub selection if user is not a restaurant
            ...(!user?.restaurant
              ? [
                  {
                    text: t("common.select_your_hub", lang),
                    sub: t("common.hub_location", lang),
                    onPress: () => {
                      return history.push("/chef/iam-a-chef/hub");
                    },
                    validator: () => {
                      return user?.selectedHub;
                    }
                  }
                ]
              : []),
            {
              text: t("common.select_your_cooking_day", lang),
              sub: t("common.your_cooking_day", lang),
              onPress: () => {
                return history.push("/chef/iam-a-chef/cooking-delivery-day");
              },
              validator: () => {
                return (
                  user?.availability &&
                  user?.availability.length > 0 &&
                  user?.time_slots &&
                  user?.time_slots.length > 0 &&
                  user?.available_days &&
                  user?.available_days.length > 0
                );
              }
            },
            {
              text: t("common.setup_banking_details", lang),
              sub: t("common.banking_details_required", lang),
              onPress: () => {
                return history.push("/chef/iam-a-chef/banking");
              },
              validator: () => {
                // Check Stripe Connect status for banking completion
                return (
                  bankingStatus?.status === "active" &&
                  bankingStatus?.payouts_enabled === true
                );
              }
            },
            {
              text: t("common.apply_for_certi", lang),
              sub: t("select_profil.food_hygiene_certificate", lang),
              onPress: () => {
                // Navigate to the certificate page
                history.push("/chef/iam-a-chef/certificate");
              },
              validator: () => {
                // Check Redux user state
                if (
                  user?.certificate_safety?.pic &&
                  user?.certificate_safety?.expirity
                ) {
                  const expirationDate = new Date(
                    user?.certificate_safety?.expirity
                  );
                  const today = new Date();
                  return expirationDate > today;
                }

                if (profil?.certificate_pic && profil?.certificate_exp) {
                  const expirationDate = new Date(profil?.certificate_exp);
                  const today = new Date();
                  return expirationDate > today;
                }

                return false;
              }
            }
          ].map((item) => (
            <div
              className="section-chef-menu-right-important-menu-block"
              onClick={() => {
                item?.onPress();
              }}
            >
              <p
                style={{
                  display: "flex",
                  gap: 10,
                  alignItems: "center",
                  marginTop: 10
                }}
              >
                {item?.validator() && <img src={Check} alt="Completed" />}
                {!item?.validator() && (
                  <img src={Uncheck} alt="Not completed" />
                )}
                <div>
                  <span
                    style={{
                      color: "#000",
                      fontSize: 16
                    }}
                  >
                    {item?.text}
                  </span>
                  <br />
                  <span
                    style={{
                      color: "#000",
                      fontSize: 14,
                      fontWeight: 300
                    }}
                  >
                    {item?.sub}
                  </span>
                </div>
              </p>
              <IoIosArrowForward size={20} />
            </div>
          ))}

          <p
            style={{
              color: "#000",
              marginTop: 40
            }}
          >
            {t("common.assistance", lang)}
          </p>
          {[
            {
              text: t("common.setup_a_call", lang),
              img: Phone,
              sub: t("common.call_only", lang),
              onPress: () => {}
            }
          ].map((item) => (
            <div
              className="section-chef-menu-right-important-menu-block"
              onClick={() => {
                item?.onPress();
              }}
            >
              <p
                style={{
                  display: "flex",
                  gap: 10,
                  alignItems: "center",
                  marginTop: 10
                }}
              >
                <img src={item?.img} alt="Assistance icon" />
                <div>
                  <span
                    style={{
                      color: "#000",
                      fontSize: 16
                    }}
                  >
                    {item?.text}
                  </span>
                  <br />
                  <span
                    style={{
                      color: "#000",
                      fontSize: 14,
                      fontWeight: 300
                    }}
                  >
                    {item?.sub}
                  </span>
                </div>
              </p>
              <IoIosArrowForward size={20} />
            </div>
          ))}
        </div>
      </div>
      <div
        style={{
          height: 80
        }}
      ></div>

      {/* Subscription Paywall Modal */}
      <SubscriptionPaywallModal
        visible={showPaywallModal}
        onClose={() => setShowPaywallModal(false)}
        onSubscribe={() => setShowPaywallModal(false)}
      />
    </div>
  );
};

export default BasicInfo;
